export default __webpack_public_path__ + "static/favicon-d6f99f8bb737ebc0fe2dd67abcb54c74.png";